import { Language } from './../objects/language';
import { List } from '../objects/list';
import { Circuit, CircuitType } from '../objects/circuit';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Preferences } from '../../profile/objects/preferences';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { CircuitCategory } from '../../circuitCategory/objects/circuitCategory';
import { CustomProvider } from "../../customProvider/objects/customProvider";
import { Contract } from "../../customProvider/objects/contract";
import { Error } from "../../manualAccommodation/objects/error";
import { SET_ERRORS } from "../../manualAccommodation/redux/actionTypes";
import { Trip } from '../../trip/objects/trip';
import { CircuitState } from '../objects/circuitState';
import { ReducedLightDestination } from '../objects/reducedLightDestination';
import { DmcProvider } from '../objects/dmcProvider';
import { Column } from '../objects/column';

export const ADD_PREFERENCES = 'CIRCUIT_ADD_PREFERENCES';
export const ADD_CIRCUIT_PERIOD = 'CIRCUIT_ADD_PERIOD';
export const DELETE_CIRCUIT_PICTURE = 'CIRCUIT_DELETE_CIRCUIT_PICTURE';
export const DELETE_CIRCUIT_PRICE = 'CIRCUIT_DELETE_CIRCUIT_PRICE';
export const MOVE_DOWN_COLUMN = 'CIRCUIT_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'CIRCUIT_MOVE_UP_COLUMN';
export const RESET_ADD_CIRCUIT = 'CIRCUIT_RESET_ADD_CIRCUIT';
export const RESET_CIRCUIT = 'CIRCUIT_RESET_CIRCUIT';
export const RESET_FILTERS = 'CIRCUIT_RESET_FILTERS';
export const SET_CIRCUIT = 'CIRCUIT_SET_CIRCUIT';
export const SET_ACCOMODATION = 'CIRCUIT_SET_ACCOMODATION';
export const SET_MANUAL_PRODUCTS = 'CIRCUIT_SET_MANUAL_PRODUCTS';
export const SET_CIRCUIT_PRICES = 'CIRCUIT_SET_CIRCUIT_PRICES';
export const SET_CUSTOM_PRODUCTS = 'CIRCUIT_SET_CUSTOM_PRODUCTS';
export const SET_CAR = 'CIRCUIT_SET_CAR';
export const SET_FLIGHT = 'CIRCUIT_SET_FLIGHT';
export const SET_PRODUCT_PERIOD = 'CIRCUIT_SET_PRODUCT_PERIOD';
export const SET_PRICES_FLIGHT = 'CIRCUIT_SET_PRICES_FLIGHT';
export const SET_PRICES_TERRESTRIAL = 'CIRCUIT_SET_PRICES_TERRESTRIAL';
export const SET_TRANSFERS = 'CIRCUIT_SET_TRANSFERS';
export const UPDATE_PRICE_TYPE = 'CIRCUIT_PRICE_TYPE';
export const UPDATE_RETURN_FLIGHT = 'CIRCUIT_RETURN_FLIGHT';
export const SET_EDIT = 'CIRCUIT_SET_EDIT';
export const SET_EDIT_STEP = 'CIRCUIT_SET_EDIT_STEP';
export const SET_EXPORT_TYPE = 'CIRCUIT_SET_EXPORT_TYPE';
export const SET_LIMIT = 'CIRCUIT_SET_LIMIT';
export const SET_LIST = 'CIRCUIT_SET_LIST';
export const SET_ORDER_BY = 'CIRCUIT_SET_ORDER_BY';
export const SET_PAGE = 'CIRCUIT_SET_PAGE';
export const SET_PREFERENCES = 'CIRCUIT_SET_PREFERENCES';
export const SET_RUNNING = 'CIRCUIT_SET_RUNNING';
export const SET_SEARCH = 'CIRCUIT_SET_SEARCH';
export const SET_MASTER_PRICE = 'CIRCUIT_SET_MASTER_PRICE';
export const TOGGLE_CANCEL_MODAL = 'CIRCUIT_TOGGLE_CANCEL_MODAL';
export const TOGGLE_COLUMN = 'CIRCUIT_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'CIRCUIT_TOGGLE_CREATE';
export const TOGGLE_EXPORT = 'CIRCUIT_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'CIRCUIT_TOGGLE_EXPORT_FULL';
export const TOGGLE_CIRCUIT_PICTURES_ORDER = 'CIRCUIT_TOGGLE_PICTURES_ORDER';
export const TOGGLE_CIRCUIT_BANNERS_ORDER = 'CIRCUIT_TOGGLE_BANNERS_ORDER';
export const TOGGLE_FILTERS = 'CIRCUIT_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'CIRCUIT_TOGGLE_REFRESH';
export const TOGGLE_CONTRACT_CREATE = 'CIRCUIT_TOGGLE_CONTRACT_CREATE';
export const UPDATE_CATEGORIES = 'CIRCUIT_UPDATE_CATEGORIES';
export const UPDATE_CIRCUIT_NAME_LOCALE = 'CIRCUIT_UPDATE_CIRCUIT_NAME_LOCALE';
export const UPDATE_CIRCUIT_NAME_LOCALES = 'CIRCUIT_UPDATE_CIRCUIT_NAME_LOCALES';
export const UPDATE_CIRCUIT_PICTURE_ORDER = 'CIRCUIT_UPDATE_CIRCUIT_PICTURE_ORDER';
export const UPDATE_DESTINATION = 'CIRCUIT_UPDATE_DESTINATION';
export const UPDATE_DURATION_DAYS = 'CIRCUIT_UPDATE_DURATION_DAYS';
export const UPDATE_DURATION_NIGHTS = 'CIRCUIT_UPDATE_DURATION_NIGHTS';
export const UPDATE_FILTER_COUNTRY = 'CIRCUIT_UPDATE_FILTER_COUNTRY';
export const UPDATE_CONTRACT_SELECTED = 'CIRCUIT_UPDATE_CONTRACT_SELECTED';
export const UPDATE_FILTER_CATEGORIES = 'CIRCUIT_UPDATE_FILTER_CATEGORIES';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'CIRCUIT_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'CIRCUIT_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'CIRCUIT_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_DESTINATION = 'CIRCUIT_UPDATE_FILTER_DESTINATION';
export const UPDATE_FILTER_PROVIDERS = 'CIRCUIT_UPDATE_FILTER_PROVIDERS';
export const UPDATE_FILTER_SOURCE = 'CIRCUIT_UPDATE_FILTER_SOURCE';
export const UPDATE_FILTER_LAST_AUTHOR = 'CIRCUIT_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_REFERENCE = 'CIRCUIT_UPDATE_FILTER_REFERENCE';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'CIRCUIT_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'CIRCUIT_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'CIRCUIT_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'CIRCUIT_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_STATUS = 'CIRCUIT_UPDATE_FILTER_STATUS';
export const UPDATE_FILTER_TYPE = 'CIRCUIT_UPDATE_FILTER_TYPE';
export const UPDATE_LIST_ITEM_VISIBILITY = 'CIRCUIT_UPDATE_LIST_ITEM_VISIBILITY';
export const UPDATE_REFERENCE = 'CIRCUIT_UPDATE_REFERENCE';
export const UPDATE_EXTERNAL_REFERENCE = 'CIRCUIT_UPDATE_EXTERNAL_REFERENCE';
export const UPDATE_DISPLAY_FOR_PACKAGE = 'CIRCUIT_UPDATE_DISPLAY_FOR_PACKAGE';
export const UPDATE_DISPLAY_FOR_TRIP_PLAN = 'CIRCUIT_UPDATE_DISPLAY_FOR_TRIP_PLAN';
export const UPDATE_SALE_PITCH_LOCALE = 'CIRCUIT_UPDATE_SALE_PITCH_LOCALE';
export const UPDATE_TRIP = 'CIRCUIT_UPDATE_TRIP';
export const UPDATE_TYPE = 'CIRCUIT_UPDATE_TYPE';
export const UPDATE_CONTRACT = 'CIRCUIT_UPDATE_CONTRACT';
export const UPDATE_PROVIDER = 'CIRCUIT_UPDATE_PROVIDER';
export const UPDATE_PERIOD_START_DATE = 'CIRCUIT_UPDATE_PERIOD_START_DATE';
export const UPDATE_PERIOD_END_DATE = 'CIRCUIT_UPDATE_PERIOD_END_DATE';
export const UPDATE_PERIOD_DAYS = 'CIRCUIT_UPDATE_PERIOD_DAYS';
export const UPDATE_PRODUCTS = 'CIRCUIT_UPDATE_PRODUCTS';
export const UPDATE_PRODUCTS_STACK = 'CIRCUIT_UPDATE_PRODUCTS_STACK';
export const DELETE_CIRCUIT_PERIOD = 'CIRCUIT_DELETE_CIRCUIT_PERIOD';
export const UPDATE_SELECTED_CIRCUIT = 'CIRCUIT_UPDATE_SELECTED_CIRCUIT';
export const UPDATE_MANY_CIRCUIT_VISIBILITY = 'CIRCUIT_UPDATE_MANY_CIRCUIT_VISIBILITY';
export const UPDATE_FILTER_LANGUAGES = 'CIRCUIT_UPDATE_FILTER_LANGUAGES';
export const SET_COLUMNS = 'CIRCUIT_SET_COLUMNS';
export const SET_DUPLICATE_CIRCUIT = 'CIRCUIT_SET_DUPLICATE_CIRCUIT';
export const SET_IS_PROTECTED_DESCRIPTION = 'CIRCUIT_SET_IS_PROTECTED_DESCRIPTION';

interface UpdateFilterLanguagesAction {
    type: typeof UPDATE_FILTER_LANGUAGES,
    payload: Language[]
}
interface UpdateManyCircuitVisibilityAction {
    type: typeof UPDATE_MANY_CIRCUIT_VISIBILITY,
    payload: {
        circuits_id: number[],
        visibility: 'PUBLIC' | 'PRIVATE_TO' | 'PRIVATE'
    }
}
interface UpdateSelectedCircuitAction {
    type: typeof UPDATE_SELECTED_CIRCUIT,
    payload: Circuit[]
}
interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface AddCircuitPeriodAction {
    type: typeof ADD_CIRCUIT_PERIOD,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetCircuitAction {
    type: typeof RESET_CIRCUIT
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetCircuitAction {
    type: typeof SET_CIRCUIT,
    payload: { circuit: Circuit | null, current_locale: number }
}

interface SetAccomodationAction {
    type: typeof SET_ACCOMODATION,
    payload: []
}

interface SetManualProductsAction {
    type: typeof SET_MANUAL_PRODUCTS,
    payload: []
}

interface SetProductPeriodAction {
    type: typeof SET_PRODUCT_PERIOD,
    payload: []
}

interface UpdateCircuitPeriodStartDateAction {
    type: typeof UPDATE_PERIOD_START_DATE,
    payload: {
        price_index: number,
        period_index: number
        value: null | Date
    }
}

interface UpdateCircuitPeriodEndDateAction {
    type: typeof UPDATE_PERIOD_END_DATE,
    payload: {
        price_index: number,
        period_index: number
        value: null | Date
    }
}

interface UpdateCircuitPeriodDaysAction {
    type: typeof UPDATE_PERIOD_DAYS,
    payload: {
        price_index: number,
        period_index: number
        value: null | Date
    }
}

interface UpdateCircuitProductsAction {
    type: typeof UPDATE_PRODUCTS,
    payload: {
        ids: number[],
        lock: boolean
    }
}

interface UpdateCircuitProductsStackAction {
    type: typeof UPDATE_PRODUCTS_STACK,
    payload: {
        ids: number[],
        is_stack_price: boolean
    }
}

interface DeleteCircuitPeriodAction {
    type: typeof DELETE_CIRCUIT_PERIOD,
    payload: {
        price_index: number,
        period_index: number
    }
}

interface SetDuplicateCircuit{
    type: typeof SET_DUPLICATE_CIRCUIT,
    payload: Circuit | null
}

interface SetPricesFlightAction {
    type: typeof SET_PRICES_FLIGHT,
    payload: []
}

interface SetPricesTerrestrialAction {
    type: typeof SET_PRICES_TERRESTRIAL,
    payload: []
}

interface SetCircuitPricesAction {
    type: typeof SET_CIRCUIT_PRICES,
    payload: [] | false
}
interface SetCustomProductsAction {
    type: typeof SET_CUSTOM_PRODUCTS,
    payload: []
}

interface SetMasterPriceAction {
    type: typeof SET_MASTER_PRICE,
    payload: []
}
interface SetCarAction {
    type: typeof SET_CAR,
    payload: []
}
interface SetFlightAction {
    type: typeof SET_FLIGHT,
    payload: []
}
interface SetTransfersAction {
    type: typeof SET_TRANSFERS,
    payload: []
}
interface UpdatePriceTypeAction {
    type: typeof UPDATE_PRICE_TYPE,
    payload: true | false
}
interface UpdateReturnFlightAction {
    type: typeof UPDATE_RETURN_FLIGHT,
    payload: true | false
}
interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: 'INFO' |
        'SALE_PITCH' |
        'CONTRACTS' |
        'ITINERARY' |
        'PRICES' |
        'PRICES_TABLE_DATES' |
        'PRODUCTS' |
        'CONTRACT_PARAMETERS' |
        'VERSIONS' |
        'CHILD_REDUCTIONS_AND_EXTRA' |
        'NIGHTS' |
        'PRICES-INFO' |
        'CANCELATION_RULES' |
        'FLIGHT_PARAMETER_INFO'
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface ToggleCircuitPicturesOrderAction {
    type: typeof TOGGLE_CIRCUIT_PICTURES_ORDER,
}
interface ToggleCircuitBannersOrderAction {
    type: typeof TOGGLE_CIRCUIT_BANNERS_ORDER,
}
interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface UpdateProviderAction {
    type: typeof UPDATE_PROVIDER,
    payload: null | CustomProvider
}


interface UpdateContractAction {
    type: typeof UPDATE_CONTRACT,
    payload: null | Contract
}

interface UpdateContractSelectedAction {
    type: typeof UPDATE_CONTRACT_SELECTED,
    payload: null | Contract
}
interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCategoriesAction {
    type: typeof UPDATE_FILTER_CATEGORIES,
    payload: null | CircuitCategory[]
}

interface UpdateFilterCountryAction {
    type: typeof UPDATE_FILTER_COUNTRY,
    payload: null | IataCountry
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterDestinationAction {
    type: typeof UPDATE_FILTER_DESTINATION,
    payload: null | ReducedLightDestination
}
interface UpdateFilterProvidersAction {
    type: typeof UPDATE_FILTER_PROVIDERS,
    payload: CustomProvider[]
}
interface UpdateFilterSourceAction {
    type: typeof UPDATE_FILTER_SOURCE,
    payload: "TRAVEL_EXCHANGE" | "OFFLINE" | "GESTOUR" | "ADALTE" | "all"
}
interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterReferenceAction {
    type: typeof UPDATE_FILTER_REFERENCE,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterStatusAction {
    type: typeof UPDATE_FILTER_STATUS,
    payload: 'ALL' | 'OFFLINE' | 'ONLINE_TO' | 'ONLINE_AGENCY'
}

interface UpdateFilterTypeAction {
    type: typeof UPDATE_FILTER_TYPE,
    payload: 'ALL' | CircuitType
}

interface UpdateListItemVisibilityAction {
    type: typeof UPDATE_LIST_ITEM_VISIBILITY,
    payload: Circuit
}

interface ResetAddCircuitAction {
    type: typeof RESET_ADD_CIRCUIT
}

interface UpdateCircuitNameLocaleAction {
    type: typeof UPDATE_CIRCUIT_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateCircuitNameLocalesAction {
    type: typeof UPDATE_CIRCUIT_NAME_LOCALES,
    payload: CircuitState['circuit_name_locales']
}

interface UpdateDurationDaysAction {
    type: typeof UPDATE_DURATION_DAYS,
    payload: number
}

interface UpdateDurationNightsAction {
    type: typeof UPDATE_DURATION_NIGHTS,
    payload: number
}

interface UpdateDestinationAction {
    type: typeof UPDATE_DESTINATION,
    payload: DestinationReduced | null
}

interface UpdateTripAction {
    type: typeof UPDATE_TRIP,
    payload: Trip
}

interface UpdateTypeAction {
    type: typeof UPDATE_TYPE,
    payload: string
}

interface UpdateReferenceAction {
    type: typeof UPDATE_REFERENCE,
    payload: string
}

interface UpdateExternalReferenceAction {
    type: typeof UPDATE_EXTERNAL_REFERENCE,
    payload: string
}

interface UpdateDisplayForPackageAction {
    type: typeof UPDATE_DISPLAY_FOR_PACKAGE,
    payload: boolean
}
interface UpdateDisplayForTripPlanAction {
    type: typeof UPDATE_DISPLAY_FOR_TRIP_PLAN,
    payload: boolean
}

interface UpdateCategoriesAction {
    type: typeof UPDATE_CATEGORIES,
    payload: null | CircuitCategory[]
}

interface UpdateSalePitchLocaleAction {
    type: typeof UPDATE_SALE_PITCH_LOCALE,
    payload: {
        id: number,
        value: string
    }
}
interface ToggleContractCreateAction {
    type: typeof TOGGLE_CONTRACT_CREATE
}

interface DeleteCircuitPictureAction {
    type: typeof DELETE_CIRCUIT_PICTURE,
    payload: number
}

interface DeleteCircuitPriceAction {
    type: typeof DELETE_CIRCUIT_PRICE,
    payload: number
}
interface SetIsProtectedDescriptionAction {
    type: typeof SET_IS_PROTECTED_DESCRIPTION,
    payload: boolean
}

interface UpdateCircuitPictureOrderAction {
    type: typeof UPDATE_CIRCUIT_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface SetEditAction {
    type: typeof SET_EDIT,
    payload: null |
        'INFO' |
        'COMPLEMENTARY_INFO'|
        'PICTURES' |
        'PICTURES_ORDER' |
        'BANNERS' |
        'BANNERS_ORDER' |
        'SALE_PITCH' |
        'VERSIONS' |
        'DESCRIPTION' |
        'KEYWORDS' |
        'STRENGTHS' |
        'CHILD_REDUCTIONS' |
        'EXTRA' |
        'ADVANTAGES' |
        'USEFULL_LINKS' |
        'SEO' |
        'VIDEO'
}

export type CircuitActionTypes =
    UpdateFilterLanguagesAction |
    UpdateManyCircuitVisibilityAction |
    UpdateSelectedCircuitAction |
    SetColumnsAction |
    AddPreferencesAction |
    AddCircuitPeriodAction |
    MoveDownColumnAction |
    DeleteCircuitPriceAction |
    MoveUpColumnAction |
    ResetCircuitAction |
    ResetFiltersAction |
    SetCircuitAction |
    SetAccomodationAction |
    SetManualProductsAction |
    SetCustomProductsAction |
    SetTransfersAction |
    SetCarAction |
    SetFlightAction |
    SetEditStepAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleNewAction |
    UpdateProviderAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleCancelModalAction |
    ToggleContractCreateAction |
    ToggleCircuitPicturesOrderAction |
    ToggleCircuitBannersOrderAction |
    ToggleRefreshAction |
    UpdateFilterCategoriesAction |
    UpdateFilterCountryAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterDestinationAction |
    UpdateFilterProvidersAction |
    UpdateFilterSourceAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterReferenceAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateContractSelectedAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterStatusAction |
    UpdateFilterTypeAction |
    ResetAddCircuitAction |
    UpdateCircuitNameLocaleAction |
    UpdateCircuitNameLocalesAction |
    UpdateDurationDaysAction |
    UpdateDurationNightsAction |
    UpdateDestinationAction |
    UpdateTripAction |
    UpdateTypeAction |
    UpdateReferenceAction |
    UpdateExternalReferenceAction |
    UpdateDisplayForPackageAction |
    UpdateDisplayForTripPlanAction |
    UpdateCategoriesAction |
    UpdateSalePitchLocaleAction |
    UpdateContractAction |
    DeleteCircuitPictureAction |
    UpdateCircuitPictureOrderAction |
    UpdateReturnFlightAction |
    UpdatePriceTypeAction |
    SetEditAction |
    SetErrorsAction |
    SetCircuitPricesAction |
    SetProductPeriodAction |
    SetPricesFlightAction |
    SetPricesTerrestrialAction |
    SetMasterPriceAction |
    UpdateListItemVisibilityAction |
    UpdateCircuitPeriodEndDateAction |
    UpdateCircuitPeriodDaysAction |
    UpdateCircuitProductsAction |
    UpdateCircuitProductsStackAction |
    DeleteCircuitPeriodAction |
    SetDuplicateCircuit |
    UpdateCircuitPeriodStartDateAction |
    SetIsProtectedDescriptionAction;
